/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Export_Csv_SuccessInputs */



/**
* | output |
* | --- |
* | "CSV downloaded." |
*
* @param {Datasets_Export_Csv_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_export_csv_success = /** @type {((inputs?: Datasets_Export_Csv_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Export_Csv_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("CSV heruntergeladen.")
	return /** @type {LocalizedString} */ ("CSV downloaded.")
});